import emailValid from '../../../utils/emailValid';
import phoneValid from '../../../utils/phoneValid';

/** First problem with the lead guest's details, or '' when fine. */
export default function validateLeadGuest({ name, emailId, phoneNumber }) {
    const cleanName = String(name || '').trim();
    if (cleanName.length < 3) return 'Please enter the guest name (at least 3 letters)';
    if (cleanName.length > 50) return 'Name should be less than 50 characters';
    if (!emailValid(emailId || '')) return 'Please enter a valid email';
    if (!phoneValid(phoneNumber || '')) return 'Please enter a valid 10 digit phone number';
    return '';
}
